import React from 'react';
import { Radio, Tooltip } from 'antd';
import { COMMON_UNIT_TOGGLE_VALUE_CHANGE } from '@src/utils/sensor/track';
import { track } from '@utils';

const getUnitList = (disablePctLocal?: boolean) => {
  return [
    { label: '#', value: '#', tooltip: 'Metric Number' },
    { label: '%', value: '%', tooltip: 'Metric Percentage' },
    {
      label: '% T',
      value: '%T',
      tooltip: 'Percentage of Total',
      disabled: disablePctLocal ?? false,
    },
  ];
};

const UNIT_CHOICES = getUnitList();
const UNIT_CHOICES_WITH_TOTAL_DISABLED = getUnitList(true);

function UnitToggle({ selectedUnit, onChange, disabled = false, totalDisabled = false }) {
  const handleChange = (e) => {
    track({ event: COMMON_UNIT_TOGGLE_VALUE_CHANGE, data: { unit: e.target.value } });
    onChange(e.target.value);
  };
  const options = totalDisabled ? UNIT_CHOICES_WITH_TOTAL_DISABLED : UNIT_CHOICES;

  return (
    <Radio.Group
      size="middle"
      onChange={handleChange}
      value={selectedUnit}
      disabled={disabled}
      optionType="button"
      style={{ display: 'flex', whiteSpace: 'nowrap' }}
    >
      {options.map((option) => (
        <Tooltip key={option.value} title={option.tooltip} placement="topRight">
          <Radio value={option.value} disabled={option.disabled}>
            {option.label}
          </Radio>
        </Tooltip>
      ))}
    </Radio.Group>
  );
}

export default UnitToggle;
